import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";
import { selectMyTeamsIds } from "../../auth/selectors";
import { uniq } from "lodash";

export const selectTeams = (state: RootState) => state.data.teams.teams;

export const selectTeam = (teamId: string) => (state: RootState) =>
  state.data.teams.teams.find((x) => x.id === teamId);

export const selectTeamCargoTypes = (teamId: string) =>
  createSelector(selectTeam(teamId), (team) => team!.cargoTypes);

export const selectTeamCargoQualities = (teamId: string) =>
  createSelector(selectTeam(teamId), (team) => team!.cargoQualities);

export const selectTeamCargoRequirements = (teamId: string) =>
  createSelector(selectTeam(teamId), (team) => team!.cargoRequirements);

export const selectTeamDrivers = (teamId: string) => (state: RootState) =>
  state.data.teams.teamsDrivers[teamId];

export const selectTeamVehicles = (teamId: string) => (state: RootState) =>
  state.data.teams.teamsVehicles[teamId];

export const selectProductGroups = (state: RootState) =>
  state.data.teams.productGroups;

export const selectTeamProductGroupIds = (teamId: string) => (state: RootState) =>
  state.data.teams.productGroups
    .filter((g) => g.teamIds.includes(teamId))
    .map((g) => g.id);

export const selectMyTeams = createSelector(
  selectTeams,
  selectMyTeamsIds,
  (teams, userTeamsIds) => {
    return teams.filter((team) => userTeamsIds.includes(team.id));
  }
);

export const selectVisibleCargoTypes = (teamId: string) =>
  createSelector(selectTeams, (userTeams) => {
    const cargoTypes = userTeams
      .filter((team) => team.id === teamId)
      .map((team) => team.cargoTypes)
      .reduce((acc, val) => acc.concat(val), []);
    return uniq(cargoTypes);
  });

export const selectVisibleCargoQualities = (teamId: string) =>
  createSelector(selectTeams, (userTeams) => {
    const cargoQualities = userTeams
      .filter((team) => team.id === teamId)
      .map((team) => team.cargoQualities)
      .reduce((acc, val) => acc.concat(val), []);
    return uniq(cargoQualities);
  });

export const selectVisibleCargoRequirements = (teamId: string) =>
  createSelector(selectTeams, (userTeams) => {
    const cargoRequirements = userTeams
      .filter((team) => team.id === teamId)
      .map((team) => team.cargoRequirements)
      .reduce((acc, val) => acc.concat(val), []);
    return uniq(cargoRequirements);
  });
